// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import * as supportListSelector from './supportListSelector';
import * as replySupportSelector from './replySupportSelector';
import * as updateReadSupportSelector from './updateReadSupportSelector';
import * as createNewSupportSelector from './createNewSupportSelector';
import * as updateSupportStatusSelector from './updateSupportStatusSelector';

const selectors = {
  ...supportListSelector,
  ...createNewSupportSelector,
  ...updateReadSupportSelector,
  ...replySupportSelector,
  ...updateSupportStatusSelector
}
export default selectors
